export default __webpack_public_path__ + "static/media/twitter.0dee700c.svg";